import React, { useEffect, useState } from "react";
import api from '../../services/api';
import Modal from 'react-modal';
import Flex from '@react-css/flex';
import Swal from "sweetalert2";
import { DynamicTextareaOnChange } from "../../components/DynamicTextarea";
import { StyledForm } from "../../styled-components/StyledForm.style";

export const ModalVisibilidadeRenovar = ({
    processo,
    laudo,
    isOpen,
    setIsOpen,
    aoSalvar
}) => {
    const [isLoading, setisLoading] = useState(false);
    const [loadAcao, setLoadAcao] = useState(null);
    const [observacao, setObservacao] = useState("");

    const style = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: "0px",
            minWidth: '35%',
            overflowY: 'auto',
            minHeight: '45%',
            maxHeight: '90%'
        },
        overlay: {
            zIndex: 9999
        }
    };

    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Credentials': false
        }
    }

    const onAfterOpen = () => { };
    const closeModal = () => { 
        setObservacao("");
        setisLoading(false);
        setIsOpen(false); 
    }

    const getLoadAcao = async (idTarefa) => {
        setisLoading(true);
        let list = null;
        try {
            const response = await api.get(`Visibilidade/tarefa/load/acao/${idTarefa}`);
            list = response.data.data;
            setLoadAcao(list);
        } catch (err) {
            console.error(err);
        } finally {
            setisLoading(false);
            return list;
        }
    }

    const campoObrigatorio = (campo) => {
        Swal.fire({
            title: "Atenção",
            html: `${campo}`,
            icon: "warning",
            confirmButtonText: "OK",
        });
    };

    const onClickAction = (idTarefa, tipoAcao) => {
        if (!observacao) { campoObrigatorio("Preencha uma Observação para Renovar"); return false; }

        Swal.fire({
            html: `Deseja Realizar essa Ação?`,
            icon: "info",
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonText: "Sim",
            cancelButtonText: "Não",
        }).then(async (result) => {
            setisLoading(true);
            if (result.isConfirmed) {
                Swal.showLoading();
                try {
                    const headers = {
                        'Content-Type': 'application/json'
                    };

                    const dados = {
                        idTipoAcao: tipoAcao,
                        observacao: observacao,
                    };
                    await api.post(`Visibilidade/tarefa/executa/renovar/${idTarefa}`, dados, { headers });
                    setisLoading(false);

                    Swal.fire({
                        title: "Sucesso",
                        text: "Tarefa Executada com Sucesso!",
                        icon: "success",
                        timer: 2000,
                        timerProgressBar: true,
                        showConfirmButton: false
                    }).then(async (result) => {;
                        setObservacao("");

                        setisLoading(false);
                        setIsOpen(false);
                        closeModal();

                        if (aoSalvar) {
                            aoSalvar(laudo.idProcesso, laudo.idTipoServico);
                        }
                    })

                } catch (err) {setisLoading(false);}
            } else {
                setisLoading(false);
            }
            
        });
    };

    useEffect(() => {
        if(isOpen) {
            getLoadAcao(processo.idTarefa);
        }
    }, [isOpen])

    return (
        <Modal
            isOpen={isOpen}
            onAfterOpen={onAfterOpen}
            onRequestClose={closeModal}
            contentLabel="Modal Iniciar"
            style={style}
            ariaHideApp={false}
            shouldCloseOnOverlayClick={false}
        >
            <StyledForm>
                <Flex>
                    <Flex.Item className="modal-width">
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="pull-left">
                                <p className="modal-title">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" width="28" height="28" className="me-2">
                                        <path fill={'#999'} d="M288 64c106 0 192 86 192 192S394 448 288 448c-65.2 0-122.9-32.5-157.6-82.3-10.1-14.5-30.1-18-44.6-7.9s-18 30.1-7.9 44.6C124.1 468.6 201 512 288 512 429.4 512 544 397.4 544 256S429.4 0 288 0C202.3 0 126.5 42.1 80 106.7L80 80c0-17.7-14.3-32-32-32S16 62.3 16 80l0 112c0 17.7 14.3 32 32 32l24.6 0c.5 0 1 0 1.5 0l86 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-38.3 0C154.9 102.6 217 64 288 64zm24 88c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 104c0 6.4 2.5 12.5 7 17l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-65-65 0-94.1z"/></svg>
                                    Renovar - { loadAcao?.nomeEtapa } </p>
                            </div>
                            <div className="pull-right">
                                <p className="modal-close" onClick={closeModal}><button className="default-button-red-small px-2">X</button></p>
                            </div>
                        </div>
                    </Flex.Item>
                </Flex>
                { isLoading ? 
                (
                <div className="text-center">
                    <div className="text-items-center">
                        <div className="spinner-border ms-auto mt-2" style={{ color: "#EE4B21" }} role="status" aria-hidden="true"></div>
                        <div className="mt-2">
                            <strong style={{ color: "#EE4B21" }}>Aguarde enquanto validamos as informações</strong>
                        </div>
                    </div>
                </div>
                ) : (
                    <>
                    <div className="row mb-2" style={{ fontSize: "14px" }}>
                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Processo</span><br/>{ loadAcao?.processo?.processoSigla || "-" }</div>
                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Líder</span><br/>{ loadAcao?.processo?.liderProcesso || "-" }</div>
                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Cliente</span><br/>{ loadAcao?.processo?.cliente || "-" }</div>
                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Segurado</span><br/>{ loadAcao?.processo?.segurado || "-" }</div>
                    </div>
                    <div className="row" style={{ fontSize: "14px" }}>
                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Disciplina</span><br/>{ laudo.disciplina }</div>
                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Responsável</span><br/>{ loadAcao?.nomeUsuarioResponsavel || "-" }</div>
                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Data Criação</span><br/>{ new Date(loadAcao?.dataCriacao).toLocaleDateString('pt-BR') }</div>
                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Data Prazo</span><br/>{ new Date(loadAcao?.dataPrazo).toLocaleDateString('pt-BR') }</div>

                    </div>
                    <div className="modal-divider" style={ { opacity: "0.3" }}><hr /></div>

                    <div className="row align-items-center justify-content-center w-100">
                        <div className="col text-center">
                            <DynamicTextareaOnChange 
                                placeholder={"Observações"} 
                                label={"Observações"} 
                                name={"observacao"}
                                valuetext={observacao}
                                onChange={(e) => setObservacao(e.target.value)}
                                required={true}
                            />
                        </div>
                    </div>
                    <div className="modal-divider" style={ { opacity: "0.3" }}><hr /></div>

                    <Flex>
                        <Flex.Item>
                            <div className="row align-items-center justify-content-center">
                                <div className="col text-center">
                                    <input 
                                        className='default-button-red' 
                                        value={'Renovar'} 
                                        type="button" 
                                        onClick={onClickAction.bind(this, loadAcao?.idTarefa, 2)}/>
                                </div>
                            </div>
                        </Flex.Item>
                    </Flex>
                    </>
                )}
            </StyledForm>
        </Modal>
    );
};